import { createSlice } from '@reduxjs/toolkit';

// Create the Redux slice
export const gameSlice = createSlice({
  name: 'game',
  initialState: {
    gameName: null,
    draws: [],
    winningNumbers: [],
    extraBets: [],
    completedGames: [],
    resultPick3: [],
    resultLotto: [],
    resultLotto_5_90: [],
    resultLotto_4_48: [],
    resultLotto_6_49: [],
    timers: {},
  },
  reducers: {
    saveDraws: (state, action) => {
      state.draws = action.payload;
    },
    saveGameName: (state, action) => {
      state.gameName = action.payload;
    },
    setWinningNumbers: (state, action) => {
      state.winningNumbers = action.payload;
    },
    saveExtraBet: (state, action) => {
      state.extraBets.push(action.payload);
    },
    addGameReachedZero: (state, action) => {
      const gameName = action.payload;
      if (!state.completedGames.includes(gameName)) {
        state.completedGames.push(gameName);
      }
    },
    setResultNumbers: (state, action) => {
      const { themeName, numbers } = action.payload;
      switch (themeName) {
        case 'pick 3':
          state.resultPick3 = numbers;
          break;
        case 'lotto 5/90':
          state.resultLotto_5_90 = numbers;
          break;
        case 'lotto 4/48':
          state.resultLotto_4_48 = numbers;
          break;
        case 'Lotto 6/49':
          state.resultLotto_6_49 = numbers;
          break;
        default:
          console.error('Invalid game name:', themeName);
          break;
      }
    },
    setTimerState: (state, action) => {
      const { themeName, timeLeft, startTime } = action.payload;
      state.timers[themeName] = { timeLeft, startTime };
    },
    resetGameTimer: (state, action) => {
      const { themeName, defaultTime } = action.payload;
      state.timers[themeName] = {
        timeLeft: defaultTime,
        startTime: Date.now(),
      };
    },

    resetDrawsForGame: (state, action) => {
      const gameNameToRemove = action.payload;
      state.draws = state.draws.filter(
        (draw) => draw.gameName !== gameNameToRemove,
      ); // Remove draws for this gameName
    },
    resetResults: (state) => {
      state.resultPick3 = [];
      state.resultLotto_5_90 = [];
      state.resultLotto_4_48 = [];
      state.resultLotto_6_49 = [];
    },
  },
});

export const {
  saveDraws,
  saveGameName,
  setWinningNumbers,
  saveExtraBet,
  addGameReachedZero,
  setResultNumbers,
  setTimerState,
  resetGameTimer,
  resetDrawsForGame,
  resetResults,
} = gameSlice.actions;

export const saveBet = (
  gameTypeVariation,
  numbers,
  stakeAmount,
  gameName,
  colorNumbers,
) => {
  return (dispatch, getState) => {
    const privateId = Math.floor(1000 + Math.random() * 9000);

    const newDraw = {
      privateId,
      gameTypeVariation,
      numbers,
      stakeAmount,
      gameName,
      colorNumbers,
    };

    const currentDraws = getState().game.draws || [];
    const updatedDraws = [...currentDraws, newDraw];
    dispatch(saveDraws(updatedDraws));
  };
};

export const saveExtraBetAction = (activeBets, colorBeting) => {
  return (dispatch) => {
    const extraBetData = { activeBets, colorBeting };
    dispatch(saveExtraBet(extraBetData));
  };
};

export default gameSlice.reducer;
